var _style, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitigAiLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n.floating-tile {\n  animation: float 3s ease-in-out infinite;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n")), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_622_690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 16,
    width: 32,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49057 39.013H22.6864C23.2223 39.0148 23.7495 38.9535 24.2682 38.829C24.7869 38.7036 25.2808 38.5195 25.7499 38.275C26.219 38.0305 26.648 37.7346 27.0371 37.3863C27.4261 37.038 27.7626 36.6492 28.0468 36.2206L38.6321 19.9966C39.6275 18.47 38.4337 16.5266 36.5001 16.5266H23.2156C22.6931 16.5239 22.1792 16.5844 21.6729 16.7062C21.1676 16.828 20.6861 17.0084 20.2284 17.2466C19.7708 17.4848 19.3522 17.7735 18.9727 18.1128C18.5932 18.452 18.2652 18.8309 17.9878 19.2496L7.35864 35.5475C6.36323 37.0687 7.55791 39.013 9.49057 39.013Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_622_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 16.5239V39.0148H39.0352V16.5239H6.99902Z",
    fill: "#4C617D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_622_690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 33,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08237 27.9H20.2782C20.8141 27.9018 21.3413 27.8405 21.86 27.716C22.3787 27.5905 22.8726 27.4065 23.3417 27.162C23.8108 26.9175 24.2398 26.6215 24.6288 26.2733C25.0179 25.925 25.3544 25.5362 25.6386 25.1076L36.2239 8.88362C37.2193 7.35704 36.0255 5.41363 34.0919 5.41363H20.8074C20.2849 5.41092 19.771 5.47137 19.2647 5.59318C18.7594 5.71498 18.2779 5.89542 17.8202 6.13361C17.3625 6.3718 16.944 6.66052 16.5645 6.99976C16.185 7.339 15.857 7.71794 15.5796 8.13657L4.95043 24.4345C3.95502 25.9557 5.14971 27.9 7.08237 27.9Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_622_690)",
    className: "floating-tile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.59082 5.41092V27.9018H36.627V5.41092H4.59082Z",
    fill: "#2E4667"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitigAiLogoIcon);
export default __webpack_public_path__ + "static/media/LitigAI-logo-icon.68b618803376211e5912bc49f75a819c.svg";
export { ForwardRef as ReactComponent };